import { Button, Drawer, Stack } from "@mui/material";

interface Props {
  isOpen: boolean;
  onClose: VoidFunction;
  children: React.ReactNode;
}

export function DrawerMenu(props: Props) {
  const { isOpen, onClose, children } = props;
  return (
    <Drawer anchor="left" open={isOpen} onClose={onClose}>
      <Stack direction="column" pl=".5rem">
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            m: ".5rem",
          }}
        >
          Close
        </Button>
        {children}
      </Stack>
    </Drawer>
  );
}
